import { EventEmitter, OnInit } from '@angular/core';
import { FOURTH_FAQ_LABELKEY, SECOND_FAQ_LABELKEY, standaloneDisneyPlusFaqsConstants, standaloneNetflixFaqsConstants, standaloneStreamzBasicFaqsConstants, standaloneStreamzFaqsConstants, standaloneStreamzPlusFaqsConstants } from '../faqs-constants';
import { OmapiIdsUtils } from '../utils/omapi-ids/omapi-ids-utils';
import { OmapiIdConstants } from '../omapi-id-constants';
var FaqsComponent = /** @class */ (function () {
    function FaqsComponent() {
        this.emitOnEnterPressed = new EventEmitter();
    }
    FaqsComponent.prototype.ngOnInit = function () {
        this.faqs = this.getCorrectSetOfFaqs(this.omapiId);
        if (OmapiIdsUtils.NETFLIX_FAQS_PACKS.includes(this.omapiId)) {
            this.enrichSecondFaq();
            this.enrichFourthFaq();
        }
    };
    FaqsComponent.prototype.emitOnEnter = function (faq) {
        this.emitOnEnterPressed.emit(faq);
    };
    FaqsComponent.prototype.getCorrectSetOfFaqs = function (omapiId) {
        var faqs;
        switch (omapiId) {
            case OmapiIdsUtils.DISNEY_PLUS_ID:
                faqs = standaloneDisneyPlusFaqsConstants;
                break;
            case OmapiIdConstants.STREAMZ:
                faqs = standaloneStreamzFaqsConstants;
                break;
            case OmapiIdConstants.STREAMZ_BASIC:
                faqs = standaloneStreamzBasicFaqsConstants;
                break;
            case OmapiIdConstants.RED_CARPET_MORE:
                faqs = standaloneStreamzPlusFaqsConstants;
                break;
            default:
                faqs = standaloneNetflixFaqsConstants;
                break;
        }
        return faqs;
    };
    FaqsComponent.prototype.enrichSecondFaq = function () {
        var secondFaq = this.faqs.filter(function (faq) { return faq.title.startsWith(SECOND_FAQ_LABELKEY); }).pop();
        secondFaq.description = SECOND_FAQ_LABELKEY + '.description-' + this.omapiId.toLowerCase();
    };
    FaqsComponent.prototype.enrichFourthFaq = function () {
        var fourthFaq = this.faqs.filter(function (faq) { return faq.title.startsWith(FOURTH_FAQ_LABELKEY); }).pop();
        fourthFaq.title = FOURTH_FAQ_LABELKEY + '.title-' + this.omapiId.toLowerCase();
        fourthFaq.description = FOURTH_FAQ_LABELKEY + '.description-' + this.omapiId.toLowerCase();
    };
    return FaqsComponent;
}());
export { FaqsComponent };
